import { ChangeDetectionStrategy, Component, HostBinding, input, OnInit, signal } from '@angular/core';
import { trigger } from '@angular/animations';

import { fadeIn } from '@core/animations/fade-animations';

import { GhostElementComponent } from '@tess-core/shared';

@Component({
  selector: 'tess-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [trigger('fadeIn', fadeIn(500))],
  imports: [GhostElementComponent],
  host: {
    '[style.--font-size]': 'fontSize()',
    '[style.--inside-width]': 'insideWidth()',
    '[style.--outside-width]': 'outsideWidth()',
    '[style.--border-shadow-color]': 'borderShadowColor()',
  },
})
export class AvatarComponent implements OnInit {
  readonly src = input<string>();
  readonly initials = input<string>();
  readonly title = input<string>();
  readonly size = input.required<string>(); // 'xxs | xs | sm | md | md2 | lg | xl';

  fontSize = signal('');
  insideWidth = signal('');
  outsideWidth = signal('');
  borderShadowColor = signal('');

  protected loaded = signal(false);

  ngOnInit(): void {
    switch (this.size()) {
      case 'xxs':
        this.fontSize.set('10px');
        this.insideWidth.set('20px');
        this.outsideWidth.set('20px');
        break;
      case 'xs':
        this.fontSize.set('10px');
        this.insideWidth.set('22px');
        this.outsideWidth.set('26px');
        break;
      case 'sm':
        this.fontSize.set('13px');
        this.insideWidth.set('28px');
        this.outsideWidth.set('32px');
        break;
      case 'md':
        this.fontSize.set('13px');
        this.insideWidth.set('32px');
        this.outsideWidth.set('36px');
        break;
      case 'md2':
        this.fontSize.set('16px');
        this.insideWidth.set('42px');
        this.outsideWidth.set('46px');
        break;
      case 'lg':
        this.fontSize.set('24px');
        this.insideWidth.set('64px');
        this.outsideWidth.set('68px');
        break;
      case 'xl':
        this.fontSize.set('27px');
        this.insideWidth.set('78px');
        this.outsideWidth.set('82px');
        break;
    }
  }

  onError(): void {
    if (this.title() && this.initials()) {
      this.loaded.set(true);
    }
  }

  onLoaded(): void {
    this.loaded.set(true);
  }
}
